import { UpdateNomenclatureQueryDTO } from '../dtoTypes'
import { UpdateNomenclatureQuery } from '../types'

export const adaptUpdateNomenclatureQuery = (
    query: UpdateNomenclatureQuery,
): UpdateNomenclatureQueryDTO => ({
    booking_nomenclature_id: query.bookingNomenclatureId,
})
